import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PageServicesRoutingModule } from './page-services-routing.module';
import { ListComponent } from './list/list.component';
import { SharedModule } from '../shared.module';
import { FormComponent } from './form/form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceService } from './services/service.service';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { NotificationsService } from '../services/notifications.service';
import { StorageService } from '../services/storage.service';
import { DetailsComponent } from './details/details.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgbModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    PageServicesRoutingModule
  ],
  declarations: [ListComponent, FormComponent, DetailsComponent],
  providers: [
    ApiService,
    LoadingService,
    NotificationsService,
    ServiceService,
    StorageService
  ]
})
export class PageServicesModule {
}
